import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { EventMediaTopperEntry } from "frontend/contentful/schema/toppers";
import { createCtaLinkProps } from "../primitives/cta-link.props";
import { createMediaAssetProps } from "../primitives/media-asset.props";
import { EventMediaTopperProps } from "design-system/components/toppers/event-media-topper/event-media-topper";
import { useContentful } from "frontend/hooks/use-contentful";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";

export const createEventMediaTopperProps = createContentfulProps<
  EventMediaTopperEntry,
  EventMediaTopperProps
>(({ entry }) => {
  const { getEntry } = useContentful();

  const eventEntry = getEntry(entry.fields.event);
  if (!eventEntry?.fields?.title) return undefined;

  const dates = [eventEntry.fields.startTime, eventEntry.fields.endTime].filter(
    (date): date is string => Boolean(date),
  );

  const description = eventEntry.fields.description
    ? RenderContentfulRichText({ document: eventEntry.fields.description })
    : undefined;

  const media = createMediaAssetProps(entry.fields.media);
  if (!media) return undefined;

  return {
    title: eventEntry.fields.title,
    description: description ?? undefined,
    dates,
    location: eventEntry.fields.location
      ? {
          title: eventEntry.fields.location
            ?.map((locationRef) => getEntry(locationRef)?.fields.title)
            .join(", "),
        }
      : undefined,
    cta: entry.fields.cta ? createCtaLinkProps(entry.fields.cta) : undefined,
    theme: entry.fields.theme,
    media,
  };
});
